import type { RequestSpec } from '@/types';

export function generateCurl(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const lines: string[] = [`curl -X ${spec.method} '${url}' \\`];
  if (hasAuth) lines.push(`  -H 'Authorization: Bearer YOUR_ACCESS_TOKEN' \\`);
  lines.push(`  -H 'Accept: application/json' \\`);
  if (spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE') {
    lines.push(`  -H 'Content-Type: application/json' \\`);
    const json = JSON.stringify(spec.body, null, 2);
    lines.push(`  --data-raw $'${escapeForBash(json)}'`);
  } else {
    // Drop trailing backslash on the last header.
    const last = lines[lines.length - 1];
    lines[lines.length - 1] = last.replace(/ \\$/, '');
  }
  return lines.join('\n');
}

function escapeForBash(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}
